import { TableResponse } from "..";
import { TaxGroup } from "./tax-group";

export enum ProductStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum ProductType {
  Wallet = "wallet",
  OtherProduct = "other_product",
}

export interface Product {
  org_id: number;
  sku: string;
  product_name: string;
  product_category_name?: string;
  income_category_name?: string;
  income_category_id?: number;
  tax_group_id?: number;
  tax_group?: TaxGroup;
  vendor?: string;
  description?: string;
  image_url?: string;
  price?: number;
  base_price?: number;
  cost?: number;
  price_master_id?: number;
  type: ProductType;
  manage_inventory: boolean;
  quantity?: number;
  status: ProductStatus;
  product_category_id?: number;
  flexible_price?:boolean;
  id?: number;
}

export type ProductTable = TableResponse<Product>;